import classnames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
import { Tooltip } from "../../../tooltip/Tooltip.js";
import styles from "./OverflowCell.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OverflowCell = /*#__PURE__*/React.memo(({
  children,
  className
}) => {
  const ref = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const maybeShowTooltip = useCallback(() => {
    if (ref.current && ref.current.clientWidth < ref.current.scrollWidth) {
      setShowTooltip(true);
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: classnames(styles.overflowCell, className),
    onMouseEnter: maybeShowTooltip,
    onMouseLeave: () => setShowTooltip(false),
    children: [children, showTooltip && /*#__PURE__*/_jsx(Tooltip, {
      content: children,
      iconRef: ref,
      open: showTooltip
    })]
  });
});